import { Modal } from "./Modal"
import { useState } from "react"


export const QuoteBanner = () => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleButtonOnClick = () => {
        setModalOpen(true);
    }
    
    return <div className="quote-banner-container">
        <Modal isOpen={modalOpen} closeModal={() => setModalOpen(false)} />
        <button className="quote-banner" onClick={handleButtonOnClick}>
            Click here to send us a message for a FREE quote!
        </button>
    </div>
}